import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useMutation } from '@apollo/react-hooks';
import {
  UpdateLeadFormJobMutation,
  UpdateLeadFormJobMutationVariables
} from './__generated__/UpdateLeadFormJobMutation';

const UPDATE_LEAD_FORM_JOB_MUTATION = gql`
  mutation UpdateLeadFormJobMutation(
    $leadgenFormDataInput: [LeadgenFormDataInput!]!
    $leadgenFormInput: FacebookLeadgenFormInput!
    $jobType: String!
  ) {
    createJobsFacebookLeadgenFormsUpdateJob(
      leadgenFormDataInput: $leadgenFormDataInput
      jobType: $jobType
      leadgenFormInput: $leadgenFormInput
    ) {
      jobsFacebookLeadgenFormsMutateJob {
        id
        status
        items {
          id
          leadgenFormId
          leadgenFormName
          itemErrors
          article {
            id
          }
        }
        jobErrors
      }
      errors
    }
  }
`;

export const useUpdateLeadFormJobMutation = () => {
  return useMutation<UpdateLeadFormJobMutation, UpdateLeadFormJobMutationVariables>(UPDATE_LEAD_FORM_JOB_MUTATION, {
    client: kmsClient
  });
};
